import { RootState } from '@/store/rootState';
import RunViewPreference from '@/core/enums/runViewPreference';
import NotificationLevel from '@/core/enums/notificationLevel';

export default {
    notificationTypes: {},
    notificationTypesList: [],
    farms: {},
    farmsList: [],
    farmVehicleTypes: [],
    farmGroups: [],
    users: {},
    usersList: [],
    userRoles: [],
    roles: {},
    rolesList: [],
    vehicles: {},
    vehiclesList: [],
    vehiclePhases: {},
    vehiclePhasesList: [],
    vehicleTypes: {},
    vehicleTypesList: [],
    currentUser: null,
    locales: {},
    runViewPreference: RunViewPreference.EXPANDED,
    visibleVehicleTypeIds: [],
    visibleNotificationLevels: [NotificationLevel.WARNING, NotificationLevel.ERROR],
    groupRuns: false,
    phones: [],
    alarmerStatus: null,
    preventMasterDataSync: false,
    resolvedRegistrationData: [],
} as RootState;
